<!-- bonus.wxml -->
<template>
    <div class="coupon-box">
        <!-- coupon -->
        <div class="coupon-list" v-if="exchargecodelist.length">
            <div :class="['list-item','clearfix']"
                 v-for="(item,index) in exchargecodelist" :key="index">
                <div class="value-box skeleton-rect">
                    <div class="value">
                        <div class="face-value">{{item.code_money}}</div>
                    </div>
                </div>
                <div class="detail-box">
                    <div class="title-box">
                        <div class="title">{{item.code_text}}</div>
                    </div>
                    <div class="description">{{item.code_num}}</div>
                    <div class="expire-time ">使用日期: {{item.create_time}}</div>
                </div>
                <div class="disabled-img" v-if="item.is_use != 0">
                    <img v-if="item.is_use == 1" src="../../assets/images/shiyong.png"/>
                    <img v-if="item.is_expire == 1" src="../../assets/images/guoqi.png"/>
                </div>
            </div>
        </div>
        <!-- no-result -->
        <div class="noresult" v-if="!exchargecodelist.length">
            <div class="cot">
                <div class="img">
                    <img src="../../assets/images/no_result.png">
                </div>
                <p class="text" style="color: #aaa;">暂无兑换码信息</p>
            </div>
        </div>
        <!-- no-result end -->
        <!-- coupon end -->
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
    import Tabber from '@/components/Tabber.vue'

    export default {
        name: 'PromoCode',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                noresult: false,
                exchargecodelist: [],
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },
        mounted() { //视图加载完成执行
            let _this = this;
            // 获取优惠码列表
            _this.getPromoCodeList();
        },
        methods: {

            /**
             * 获取优惠码列表
             */
            getPromoCodeList: function () {
                let _this = this;
                _this._get('user.index/usercode', {}, function (result) {
                    _this.loading.hide();
                    _this.setData({
                        exchargecodelist: result.exchargecodelist,
                    });
                });
            },

        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss">
    @import "promo_code.scss";
</style>
